import { render, staticRenderFns } from "./Importer.vue?vue&type=template&id=01513489&scoped=true&"
import script from "./Importer.vue?vue&type=script&lang=js&"
export * from "./Importer.vue?vue&type=script&lang=js&"
import style0 from "./Importer.vue?vue&type=style&index=0&id=01513489&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01513489",
  null
  
)

export default component.exports